import { render, staticRenderFns } from "./ProyeccionMovimiento.vue?vue&type=template&id=d8b88420&scoped=true"
import script from "./ProyeccionMovimiento.vue?vue&type=script&setup=true&lang=js"
export * from "./ProyeccionMovimiento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProyeccionMovimiento.vue?vue&type=style&index=0&id=d8b88420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b88420",
  null
  
)

export default component.exports